export const MEASURING_POINT_CELL_CLASSES = 'px-4 py-3 align-top text-xs text-gray-700';

/** A cell element that opens a tooltip on hover, focus or tap. */
export const TOOLTIP_TRIGGER_CLASSES = 'cursor-pointer touch-manipulation';

/** The icon buttons in the overview rows: expand, star and options. */
export const ROW_ICON_BUTTON_CLASSES =
    'inline-flex h-7 w-7 items-center justify-center rounded text-base text-gray-700 transition-colors enabled:hover:bg-gray-100';
